import React from 'react';
import { ArrowUpRightIcon, CheckIcon } from 'lucide-react';
const plans = [{
  name: 'CAMPAIGN',
  title: 'Start with one experience.',
  description: 'A focused way to bring a product drop, local activation, or launch moment into the Sampler experience.',
  includes: ['Campaign direction', 'Experience setup', 'Campaign review view']
}, {
  name: 'PROGRAMME',
  title: 'Make product experience a channel.',
  description: 'For teams building a connected calendar of product moments across markets, audiences, or launches.',
  includes: ['Multi-campaign planning', 'Shared learning view', 'Programme support'],
  featured: true
}, {
  name: 'ENTERPRISE',
  title: 'Build the infrastructure together.',
  description: 'For organisations exploring a tailored product experience layer across brand, media, retail, and activation.',
  includes: ['Custom operating model', 'Partner integration direction', 'Dedicated planning']
}];
export function PricingSection() {
  return <section id="pricing" className="bg-white px-5 py-24 md:px-10 md:py-32" aria-labelledby="pricing-heading" data-id="element-601" data-mp="7vmtj5p83u9h">
      <div className="mx-auto max-w-[1280px]" data-id="element-602" data-mp="1hq81xt1rtrz1">
        <div className="grid gap-8 border-b border-black/15 pb-12 md:grid-cols-[1fr_0.75fr] md:items-end" data-id="element-603" data-mp="1hodf296xvpsb">
          <div data-id="element-604" data-mp="1cr4uk1ybj9nw">
            <p className="text-xs font-extrabold tracking-[0.16em] text-black/50" data-id="element-605" data-mp="1cosc7nonexab">
              PRICING THAT FITS THE EXPERIENCE
            </p>
            <h2 id="pricing-heading" className="mt-5 font-display text-5xl font-bold leading-[0.88] md:text-7xl" data-id="element-606" data-mp="25fsn8iled1bh">
              Start with a drop.
              <br data-id="element-607" data-mp="20ecxwec6s8na" />
              Build a <span className="text-[#ff4d17]" data-id="element-608" data-mp="1vh312dmgwupf">programme.</span>
            </h2>
          </div>
          <p className="max-w-xl text-lg leading-relaxed text-black/70" data-id="element-609" data-mp="1rfri2qy3n7q7">
            Every product experience is shaped around its audience, location,
            partner model, and campaign ambition. Pricing is scoped with you —
            not guessed on a page.
          </p>
        </div>

        <div className="mt-12 grid gap-4 lg:grid-cols-3" data-id="element-610" data-mp="hhrtmzpwf1o7">
          {plans.map(plan => <article key={plan.name} className={`flex min-h-[440px] flex-col border p-7 md:p-8 ${plan.featured ? 'border-[#ff4d17] bg-[#ff4d17] text-black shadow-[10px_10px_0_#11110f]' : 'border-black/15 bg-[#f7f5ef]'}`} data-id="element-611" data-mp="hfot3lr4dq58">
              <p className="text-xs font-extrabold tracking-[0.14em] opacity-65" data-id="element-612" data-mp="ciomn9qcyldl">
                {plan.name}
              </p>
              <h3 className="mt-9 font-display text-4xl font-bold leading-[0.9]" data-id="element-613" data-mp="3uwebk8m8sdp2">
                {plan.title}
              </h3>
              <p className="mt-6 text-base leading-relaxed text-black/70" data-id="element-614" data-mp="3jjow5mmew2h">
                {plan.description}
              </p>

              <div className="mt-8 border-t border-current/20 pt-6" data-id="element-615" data-mp="3kwnimbdby6r3">
                <p className="text-xs font-extrabold tracking-[0.12em]" data-id="element-616" data-mp="3py30xvo4hz5s">
                  INCLUDED DIRECTION
                </p>
                <ul className="mt-4 space-y-3 text-sm font-semibold" data-id="element-617" data-mp="3c067v98voavv">
                  {plan.includes.map(item => <li key={item} className="flex gap-3" data-id="element-618" data-mp="3g185xmr26gw9">
                      <CheckIcon className="mt-0.5 shrink-0" size={16} aria-hidden="true" data-id="element-619" data-mp="2xbwfdm7ymmtq" />
                      {item}
                    </li>)}
                </ul>
              </div>

              <div className="mt-auto pt-8" data-id="element-620" data-mp="36cuh1xuxei95">
                <p className="text-sm font-bold" data-id="element-621" data-mp="369f1ktxcb777">PRICING ON REQUEST</p>
                <a href="#start" className={`mt-4 inline-flex min-h-12 items-center gap-2 rounded-full px-5 text-sm font-extrabold ${plan.featured ? 'bg-black text-white hover:bg-[#11110f]/80' : 'bg-[#11110f] text-white hover:bg-black/75'}`} data-id="element-622" data-mp="31b56ejbm86ll">
                  TALK TO US <ArrowUpRightIcon size={16} aria-hidden="true" data-id="element-623" data-mp="3p212hsn3tnyn" />
                </a>
              </div>
            </article>)}
        </div>
        <p className="mt-8 text-xs font-bold leading-relaxed text-black/55" data-id="element-624" data-mp="3l1z4btgkvco4">
          Scope, availability, partner participation, and commercial terms are
          agreed per programme. This is an indicative service structure, not a
          published rate card.
        </p>
      </div>
    </section>;
}